export const getAuthorDisplayName = (author) => {
    let displayName = author?.display_name || '';

    if (!displayName) {
        displayName = `${author?.first_name || ''} ${author?.last_name || ''}`;
    }

    return displayName;
}